import React, { useState } from 'react'
import { BpInput } from '../../../../shared/components/forms/input/BpInput'
import { BpButton } from '../../../../shared/components/buttons/bp-button/BpButton'
import { hideModal } from '../../../../app/store/reducers/AppSlice'
import { useTranslation } from 'react-i18next'
import { useAppDispatch } from '../../../../app/store/hooks/Redux'
import styles from './AddParameter.module.scss'

interface Props {
  currentParameters: string[]
  onSubmit: (string: string) => void
}

export const AddParameter = ({ currentParameters, onSubmit }: Props) => {
  const { t } = useTranslation()
  const [value, setValue] = useState('')
  const [isFocus, setIsFocus] = useState<boolean>(false)
  const dispatch = useAppDispatch()

  return (
    <div className={styles.root}>
      <div className={styles.titleWrap}>
        <h3 className={styles.title}>
          {t('pages.project.addParameter')}
        </h3>
      </div>
      <div className={styles.body}>
        <BpInput
          required
          error={
            currentParameters.some((param) => param.toLowerCase() === value.toLowerCase())
              ? t('pages.project.validate.parameterNameAlreadyExists')
              : !value && isFocus
                ? t('fields.validate.parameterNameRequired')
                : isFocus && !/^[A-Za-z0-9\-._~]+$/.test(value)
                  ? t('pages.project.validate.parameterNameInvalid')
                  : ''
          }
          placeholder={t('pages.project.parameterExample')}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onFocus={() => setIsFocus(true)}
        />
        <p className={styles.hint}>
          ✅ {t('other.correct')}: utm_campaign
          <br />❌ {t('other.incorrect')}: utm_campaign=google_ads
          <br />❌ {t('other.incorrect')}: https://example.com/?utm_campaign=google_ads
        </p>
      </div>
      <div className={styles.footer}>
        <BpButton
          disabled={
            !value ||
            currentParameters.some((param) => param.toLowerCase() === value.toLowerCase()) ||
            !/^[A-Za-z0-9\-._~]+$/.test(value)
          }
          className={styles.addButton}
          type='button'
          onClick={() => {
            onSubmit(value)
            dispatch(hideModal())
          }}
        >
          {t('buttons.add')}
        </BpButton>
        <BpButton theme='transparent' type='button' onClick={() => dispatch(hideModal())}>
          {t('buttons.cancel')}
        </BpButton>
      </div>
    </div>
  )
}
